import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';
import Footer from '@features/Footer/Footer';
import React from 'react';
import HzTheme from '../../theme/HzTheme';
import LayoutHeader from '@features/Header/LayoutHeader';

const AppLayout = () => {
  const [alertBannerHeight, setAlertBannerHeight] = useState<number>(0);

  return (
    <ThemeProvider theme={HzTheme}>
      <CssBaseline />
      <Box
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        bgcolor={HzTheme.palette.offwhite?.main}
      >
        <Suspense>
          <LayoutHeader onAlertHeightChange={setAlertBannerHeight} />
        </Suspense>
        <Box
          flexGrow={1}
          sx={{
            marginTop: alertBannerHeight
              ? `calc(${alertBannerHeight}px + 3.5rem)`
              : '3.5rem',
          }}
        >
          <Suspense>
            <Outlet />
          </Suspense>
        </Box>
        <Suspense>
          <Footer />
        </Suspense>
      </Box>
    </ThemeProvider>
  );
};

export default AppLayout;
